export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.618 3.199a.438.438 0 01.121.606l-5.25 7.875a.437.437 0 01-.673.067l-3.5-3.5a.438.438 0 01.618-.619l3.123 3.123 4.954-7.431a.437.437 0 01.607-.121z\" fill=\"currentColor\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "14",
    "height": "15",
    "viewBox": "0 0 14 15",
    "fill": "none"
  }
};